export type PhoneValidationError = "phoneRequired" | "phoneInvalid";

const PHONE_PATTERN = /^\+[1-9]\d{7,14}$/;

export function normalizePhone(phone: string): string {
  const trimmed = phone.trim();
  if (!trimmed) return "";

  if (trimmed.startsWith("+")) {
    return `+${trimmed.slice(1).replace(/\D/g, "")}`;
  }

  const digits = trimmed.replace(/\D/g, "");
  return digits ? `+${digits}` : "";
}

export function validatePhone(phone: string): PhoneValidationError | null {
  const normalized = normalizePhone(phone);
  if (!normalized) return "phoneRequired";
  if (!PHONE_PATTERN.test(normalized)) return "phoneInvalid";
  return null;
}
